import Webcam from './Webcam.vue';
export default Webcam;
